import React from 'react';
import PropTypes from 'prop-types';

// import components
import SortMobileFilter from '@/kenwood/components/molecules/SortMobileFilter';
import FacetMobile from '@/kenwood/components/molecules/FacetMobile';

const FiltersPopupMobileContent = ({
  areMobileFiltersOpen,
  facets,
  sorts,
  sortByLabel,
  onApplyFilter,
  onApplySort,
}) => (
  <section className='ken-plp__filters__mobile-popup__content'>
    <SortMobileFilter
      areMobileFiltersOpen={areMobileFiltersOpen}
      sorts={sorts}
      sortByLabel={sortByLabel}
      onApplySort={onApplySort}
    />
    {facets.map(facet => (
      <FacetMobile
        key={facet.code}
        areMobileFiltersOpen={areMobileFiltersOpen}
        facet={facet}
        onApplyFilter={onApplyFilter}
      />
    ))}
  </section>
);

FiltersPopupMobileContent.propTypes = {
  areMobileFiltersOpen: PropTypes.bool,
  facets: PropTypes.arrayOf(PropTypes.shape()),
  sorts: PropTypes.arrayOf(PropTypes.shape()),
  sortByLabel: PropTypes.string.isRequired,
  onApplyFilter: PropTypes.func,
  onApplySort: PropTypes.func,
};

FiltersPopupMobileContent.defaultProps = {
  areMobileFiltersOpen: false,
  facets: [],
  sorts: [],
  onApplyFilter: null,
  onApplySort: null,
};

export default FiltersPopupMobileContent;
